import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgModule } from '@angular/core';
import { DepositNeosurfComponent } from './deposit-neosurf.component';
import { DepositNeosurfActionComponent } from './deposit-neosurf-action.component';
@NgModule({
    declarations: [
        DepositNeosurfComponent,
        DepositNeosurfActionComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        ComponentsModule
    ],
})
export class DepositNeosurfModule { }
